import Cookies from 'js-cookie'

const tokenCookie = 'Authorization'

export const removeTokenCookie = (): void => Cookies.remove(tokenCookie)

const employeeIdCookieKey = 'employeeId'

export const getEmployeeIdCookie = (): string | null =>
  Cookies.get(employeeIdCookieKey) || null

export const removeEmployeeIdCookie = (): void =>
  Cookies.remove(employeeIdCookieKey)

export const cleanUpCookieandStorage = () => {
  removeEmployeeIdCookie()
  removeTokenCookie()
}
